import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useCustomer } from "../lib/auth";

/** Handles `#session_id=` after Google sign-in: exchanges it server-side, then lands on /account. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomer();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/account/session", { session_id: sessionId });
        setUser(data);
        toast.success(`Welcome, ${data.name.split(" ")[0]}!`);
      } catch (err) {
        setUser(null);
        toast.error(formatApiError(err));
      } finally {
        window.history.replaceState(null, "", location.pathname);
        navigate("/account", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <main className="flex min-h-[70vh] items-center justify-center bg-parchment pt-32" data-testid="auth-callback">
      <Loader2 size={36} className="animate-spin text-spice" />
    </main>
  );
}
